export default "__VITE_ASSET__BKQPDy2P__"